import { COLLECT_PERIODS_TYPES } from "./collectPeriodsTypes";

const {
  LOAD_COLLECT_PERIODS,
  SET_COLLECT_PERIODS,
  NEW_COLLECT_PERIOD,
  SET_NEW_COLLECT_PERIOD,
  EDIT_COLLECT_PERIOD,
  SET_EDITED_COLLECT_PERIOD,
  DELETE_COLLECT_PERIOD,
  CLEAR_COLLECT_PERIODS,
  HANDLE_COLLECT_PERIODS_INPUTS,
} = COLLECT_PERIODS_TYPES;

const initialState = {
  isLoadingPage: false,
  collectPeriods: [],
  collectPeriodList: [],
  types: [],
  station: null,

  //edit
  isAddMode: false,
  isDeleteMode: false,
  editCollectPeriod: null,

  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: []
  }
};

const toLabelElement = period => ({
  id: period.id,
  label: `${period.name} - ${period.type}`,
  value: period.id
});

export const collectPeriodsReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case HANDLE_COLLECT_PERIODS_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case LOAD_COLLECT_PERIODS:
      return {
        ...state,
        isLoadingPage: true
      };

    case SET_COLLECT_PERIODS:
      return {
        ...state,
        isLoadingPage: false,
        collectPeriods: payload.collectPeriods,
        collectPeriodList: payload.collectPeriods.map(toLabelElement),
        types: payload.types
      };

    case EDIT_COLLECT_PERIOD:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: false,
        editCollectPeriod: payload
      };

    case NEW_COLLECT_PERIOD:
      return {
        ...state,
        isAddMode: true,
        isDeleteMode: false
      };

    case SET_NEW_COLLECT_PERIOD: {
      const newCollectPeriods = [payload, ...state.collectPeriods];

      return {
        ...state,
        collectPeriods: newCollectPeriods
      };
    }

    case SET_EDITED_COLLECT_PERIOD: {
      const newCollectPeriods = [...state.collectPeriods];
      const indexToEdit = newCollectPeriods.findIndex(
        collectPeriod => collectPeriod.id === payload.id
      );

      if (indexToEdit !== -1) {
        newCollectPeriods[indexToEdit] = payload;
      }

      return {
        ...state,
        collectPeriods: newCollectPeriods
      };
    }

    case DELETE_COLLECT_PERIOD:
      return {
        ...state,
        isAddMode: false,
        isDeleteMode: true
      };

    case CLEAR_COLLECT_PERIODS:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
};
